import React, {useEffect } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { Dropdown } from "react-bootstrap";
import LogoutPage from './Logout';
import { authActions } from "../../../_store";
import CommonService from "../../../services/Common/CommonService";

const Header = ({ onNote }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector(x => x.auth.user);
  const NotificationCount = useSelector(x => x.auth.NotificationCount);

  

  useEffect(() => {
    const fetchChatData = async () => {
      try {
        CommonService.GetNotificationCount(currentUser?.Id).then((res) => {
          if (res?.status===200) {
            let userDetail={...currentUser};
            userDetail.NotificationCount=res?.data;
           dispatch(authActions.updateLocalStorage(userDetail));

          }
        });
        
      } catch (error) {
        console.error("Error fetching chat data:", error);
      }
    };

    // Fetch chat data every 5 seconds 5000
    const interval = setInterval(fetchChatData, 5000);

    // Cleanup interval when component unmounts
    return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {

    if(NotificationCount && NotificationCount >0)
    {
      const audio = new Audio("/sounds/notificationLivechat.mp3");
      audio.play();
    }
  
}, [NotificationCount]);

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">

            </div>
            <ul className="navbar-nav header-right main-notification">
            <Dropdown
                as="li"
                className="nav-item dropdown notification_dropdown "
                title='View chat list by clicking here'
              >
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="nav-link bell bell-link i-false c-pointer ai-icon"
                  onClick={() => onNote()}
                >
					<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clipPath="url(#clip0)">
						<path d="M23.9161 4.16311C21.1983 1.41256 17.4654 -0.0936897 13.6016 0.00454401C5.90661 0.233756 -0.118391 6.61895 0.110821 14.3139C0.143566 15.9184 0.471011 17.4902 1.06041 18.9637C1.55158 20.208 2.20647 21.354 3.02509 22.4018L1.87903 25.1196C1.4206 26.1675 1.91177 27.379 2.9596 27.8374C3.31979 28.0012 3.74547 28.0339 4.1384 27.9684L9.44303 27.0516C11.3422 27.7065 13.3396 27.9357 15.337 27.7392C22.1807 27.0516 27.518 21.4522 27.8782 14.5759C28.0747 10.6793 26.6339 6.91365 23.9161 4.16311ZM12.9794 19.4548H9.34479C8.78813 19.4548 8.29697 18.9964 8.29697 18.407C8.29697 17.8503 8.75539 17.3592 9.34479 17.3592H12.9794C13.5361 17.3592 14.0273 17.8176 14.0273 18.407C14.0273 18.9964 13.5688 19.4548 12.9794 19.4548ZM18.6443 15.198H9.34479C8.78813 15.198 8.29697 14.7396 8.29697 14.1502C8.29697 13.5608 8.75539 13.1024 9.34479 13.1024H18.6443C19.2009 13.1024 19.6921 13.5608 19.6921 14.1502C19.6921 14.7396 19.2009 15.198 18.6443 15.198ZM18.6443 10.9085H9.34479C8.78813 10.9085 8.29697 10.4501 8.29697 9.86066C8.29697 9.304 8.75539 8.81284 9.34479 8.81284H18.6443C19.2009 8.81284 19.6921 9.27126 19.6921 9.86066C19.6921 10.4173 19.2009 10.9085 18.6443 10.9085Z" fill="#737B8B"/>
						</g>
						<defs>
						<clipPath id="clip0">
						<rect width="28" height="28" fill="white"/>
						</clipPath>
						</defs>
					</svg>
              <span className="badge light text-white bg-orange rounded-circle">{NotificationCount}</span>
                </Dropdown.Toggle>
              </Dropdown>


              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
                  <div className="header-info me-3">
                    <span className="fs-18 font-w500 text-end">{currentUser.FirstName}</span>
                    <small className="text-end fs-14 font-w400">{currentUser.EmailID}</small>
                  </div>
                  <LogoutPage />
                </Dropdown.Toggle>

                {/* <Dropdown.Menu align="right" className="mt-1 dropdown-menu dropdown-menu-end"> */}
                {/* <Link to="/app-profile" className="dropdown-item ai-icon">
                    <svg
                      id="icon-user1" xmlns="http://www.w3.org/2000/svg" className="text-primary"
                      width={18} height={18} viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span className="ms-2">Profile </span>
                  </Link> */}

                {/* </Dropdown.Menu> */}
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
